import { getUrl } from '@/common/oldMobile';
import reframe from 'nike-re-framejs';
import { getObject, setObject } from '@/services/localStorage';
import Immutable, { List } from 'immutable';
import axios from 'axios';
import { catcher, toWwwForm } from '@/_http/utils';
import { userFavouritePath } from './handlers';

const FAVOURITE_ITEMS = 'favourite.items';
const FAVOURITE_MARKETS = 'favourite.markets';

/* OBLUBENE BOXY */
export const addFavouriteItemToServer = boxId => {
    axios
        .post(getUrl('USER_FAVOURITE_MENU_ITEMS_ADD'), { boxId })
        .then(json => reframe.dispatch(['favourites.updated', json]))
        .catch(catcher.swallow);
};

export const removeFavouriteItemFromServer = boxId => {
    axios
        .post(getUrl('USER_FAVOURITE_MENU_ITEMS_DELETE'), { boxId })
        .then(json => reframe.dispatch(['favourites.updated', json]))
        .catch(catcher.swallow);
};

export function removeFavouriteItemFromModel(db, boxId) {
    let newDb = db.updateIn([...userFavouritePath, 'menuItems'], Immutable.Set(), menuItems => menuItems.remove(boxId));
    saveFavoritesMenuItemsToLS(newDb.getIn([...userFavouritePath, 'menuItems']));
    return newDb;
}

export function addFavouriteItemToModel(db, boxId) {
    let newDb = db.updateIn([...userFavouritePath, 'menuItems'], Immutable.Set(), items => items.add(boxId));
    saveFavoritesMenuItemsToLS(newDb.getIn([...userFavouritePath, 'menuItems']));
    return newDb;
}

export function loadFavoritesMenuItemsFromLS() {
    return Immutable.Set(getObject(FAVOURITE_ITEMS) || []);
}

export function saveFavoritesMenuItemsToLS(boxIds = Immutable.Set()) {
    setObject(FAVOURITE_ITEMS, boxIds.toJS());
}

/* OBLUBENE MARKETY */

export const addFavouriteMarketToServer = marketId => {
    axios
        .post(getUrl('USER_FAVOURITE_MARKET_ADD'), { marketId })
        .then(json => reframe.dispatch(['favourites.updated', json]))
        .catch(catcher.swallow);
};

export const removeFavouriteMarketFromServer = marketId => {
    axios
        .post(getUrl('USER_FAVOURITE_MARKET_DELETE'), { marketId })
        .then(json => reframe.dispatch(['favourites.updated', json]))
        .catch(catcher.swallow);
};

export function removeFavouriteMarketFromModel(db, marketId) {
    let newDb = db.updateIn([...userFavouritePath, 'markets'], Immutable.Set(), markets => markets.remove(marketId));
    saveFavoritesMarketsToLS(newDb.getIn([...userFavouritePath, 'markets']));
    return newDb;
}

export function addFavouriteMarketToModel(db, marketId) {
    let newDb = db.updateIn([...userFavouritePath, 'markets'], Immutable.Set(), markets => markets.add(marketId));
    saveFavoritesMarketsToLS(newDb.getIn([...userFavouritePath, 'markets']));
    return newDb;
}

export function loadFavoritesMarketsFromLS() {
    return Immutable.Set(getObject(FAVOURITE_MARKETS) || []);
}

export function saveFavoritesMarketsToLS(markets = Immutable.Set()) {
    setObject(FAVOURITE_MARKETS, markets.toJS());
}

/* OBLUBENE KASINO HRY */

export const addFavouriteCasinoVegasGamesToServer = gameId => {
    axios
        .post(getUrl('CASINO_FAVOURITE_ADD'), toWwwForm({ gameId }))
        .then(json => reframe.dispatch(['favourites.updated', json]))
        .catch(catcher.swallow);
};

export const removeFavouriteCasinoVegasGamesFromServer = gameId => {
    axios
        .post(getUrl('CASINO_FAVOURITE_REMOVE'), toWwwForm({ gameId }))
        .then(json => reframe.dispatch(['favourites.updated', json]))
        .catch(catcher.swallow);
};

export function addFavouriteCasinoVegasGamesToModel(db, gameId) {
    return db.updateIn([...userFavouritePath, 'casinoVegasGames'], List(), games => games.push(gameId));
}

export function removeFavouriteCasinoVegasGamesFromModel(db, gameId) {
    return db.updateIn([...userFavouritePath, 'casinoVegasGames'], List(), games =>
        games.filter(favoriteGameId => favoriteGameId !== gameId)
    );
}

export const setDarkTheme = enabled => axios.post(getUrl('DARK_THEME'), { enabled }).catch(catcher.swallow);
